import { render, staticRenderFns } from "./IconClassBookLight.vue?vue&type=template&id=4f86cfc3&"
import script from "./IconClassBookLight.vue?vue&type=script&lang=js&"
export * from "./IconClassBookLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports